


















// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck Fix typing issues later
import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import { ClientInfo, UpdateCompanyInfoRequest } from "@/types";
import { BusinessOwner } from "@/proto/admin/all_pb";
import { COUNTRY_MOBILE_CODES } from "@/constant";

import EditBusinessOwnerForm from "@/pagesCom/ClientInfo/EditBusinessOwner/index.vue";
import EditTemplate from "@/pagesCom/ClientInfo/EditTemplate.vue";
import { getAddressTitle } from "@/pagesCom/ClientInfo/EditBusinessOwner/helpers";

import {
  ECountryCode,
  EDomicileTypes,
} from "../../pagesCom/ClientInfo/index.dto";
import {
  ESummaryContentType,
  IEditSummaryData,
} from "@/pagesCom/ClientInfo/EditSummary/index.dto";

export interface FormData {
  fullname: string;
  placeofbirth: string;
  dateofbirth: string;
  gender: string;
  occupation: string;
  phonenumber: string;
  phonenumbercountrycode: string;
  email: string;
  isuscitizen: boolean;
  citizenship: string;
  taxidentificationnumber?: string;

  registeredaddressline1: string;
  registeredaddressline2?: string;
  registeredcountry?: string;
  registeredregion: string;
  registeredcity: string;
  registeredzipcode: string;

  currentaddressline1: string;
  currentaddressline2?: string;
  currentcountry?: string;
  currentregion: string;
  currentcity: string;
  currentzipcode: string;
}

const clientModule = namespace("client");
@Component({
  components: {
    EditTemplate,
    EditBusinessOwnerForm,
  },
})
export default class EditBusinessOwnerPage extends Vue {
  @clientModule.Action("updateBusinessOwner") updateBusinessOwner!: (
    payload: UpdateCompanyInfoRequest
  ) => void;
  @clientModule.State("currentClient") currentClient!: ClientInfo;

  // Data
  loading = false;
  showSummary = false;
  summaryData: IEditSummaryData[] = [];
  countryCodes = COUNTRY_MOBILE_CODES;
  errorMsg = null;

  onCancel() {
    const { clientId } = this.$route.params;
    this.$router.push(`/client/${clientId}`);
  }

  _formatPayload(data: FormData): BusinessOwner.AsObject {
    const {
      fullname,
      placeofbirth,
      dateofbirth,
      gender,
      occupation,
      phonenumber,
      phonenumbercountrycode,
      email,
      isuscitizen,
      citizenship,
      taxidentificationnumber,
      registeredaddressline1,
      registeredaddressline2,
      registeredcountry,
      registeredregion,
      registeredcity,
      registeredzipcode,
      currentaddressline1,
      currentaddressline2,
      currentcountry,
      currentregion,
      currentcity,
      currentzipcode,
    } = data;

    return {
      fullname,
      placeofbirth,
      dateofbirth: dateofbirth ? moment(dateofbirth).format("DD MMM YYYY") : "",
      gender,
      occupation,
      phonenumber,
      phonenumbercountrycode,
      email,
      isuscitizen,
      citizenship,
      taxidentificationnumber,
      registeredaddressline1,
      registeredaddressline2,
      registeredcountry,
      registeredregion,
      registeredcity,
      registeredzipcode,
      currentaddressline1,
      currentaddressline2,
      currentcountry,
      currentregion,
      currentcity,
      currentzipcode,
    };
  }

  _handleSummary(data: FormData): IEditSummaryData[] {
    const dynamicAddressName = getAddressTitle(
      this.currentClient?.country as ECountryCode,
      this.currentClient?.domicileType as EDomicileTypes
    );

    const sharedField = [
      {
        type: ESummaryContentType.TEXT,
        label: "Full Name",
        content: [data.fullname],
      },
      {
        type: ESummaryContentType.TEXT,
        label: "Citizenship",
        content: [data.citizenship],
      },
      {
        type: ESummaryContentType.TEXT,
        label: "Phone Number",
        content: [`${data.phonenumbercountrycode} ${data.phonenumber}`],
      },
      {
        type: ESummaryContentType.TEXT,
        label: "Email",
        content: [data.email],
      },
      {
        type: ESummaryContentType.TEXT,
        label: dynamicAddressName,
        content: [
          data.registeredaddressline1,
          data.registeredaddressline2,
          data.registeredregion,
          `${data.registeredcity} ${data.registeredzipcode}`,
          data.registeredcountry,
        ],
      },
      {
        type: ESummaryContentType.TEXT,
        label: "Current Address",
        content: [
          data.currentaddressline1,
          data.currentaddressline2,
          data.currentregion,
          `${data.currentcity} ${data.currentzipcode}`,
          data.currentcountry,
        ],
      },
    ];

    switch (this.currentClient?.country) {
      case ECountryCode.ID:
        return [
          {
            content: [
              {
                label: "Place of birth",
                type: ESummaryContentType.TEXT,
                content: [data.placeofbirth],
              },
              {
                label: "Date of birth",
                type: ESummaryContentType.TEXT,
                content: [
                  data.dateofbirth
                    ? moment(data.dateofbirth).format("DD MMM YYYY")
                    : "",
                ],
              },
              {
                label: "Gender",
                type: ESummaryContentType.TEXT,
                content: [data.gender],
              },
              {
                label: "Occupation",
                type: ESummaryContentType.TEXT,
                content: [data.occupation],
              },
              ...sharedField,
            ],
          },
        ];
      case ECountryCode.PH:
        return [
          {
            content: [
              {
                label: "Tax ID No.",
                type: ESummaryContentType.TEXT,
                content: [data.taxidentificationnumber],
              },

              ...sharedField,
            ],
          },
        ];
      default:
        return [];
    }
  }

  async onSubmit(data: FormData) {
    this.errorMsg = null;
    this.loading = true;

    try {
      const { clientId } = this.$route.params;
      const payload: BusinessOwner.AsObject = this._formatPayload(data);
      await this.updateBusinessOwner({ clientId, data: payload });

      this.showSummary = true;
      this.summaryData = this._handleSummary(data);
    } catch (err) {
      this.errorMsg = err.message;
      console.error("Failed to update Business Owner:", err.message);
    } finally {
      this.loading = false;
    }
  }
}
